import { render, staticRenderFns } from "./IssueSecurityRiskTableCell.vue?vue&type=template&id=1640e08e&scoped=true"
import script from "./IssueSecurityRiskTableCell.vue?vue&type=script&lang=js"
export * from "./IssueSecurityRiskTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueSecurityRiskTableCell.vue?vue&type=style&index=0&id=1640e08e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640e08e",
  null
  
)

export default component.exports